<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <form @submit.prevent="TraineeForm">
          <div class="container-fluid mt-5">
            <div class="col-sm-12">
              <div class="row dblock">
                <!-- style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);" -->
                <vs-breadcrumb
                  align="left"
                  :items="[
                    { title: 'You are here : ' },
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/trainee/traineeDashboard',
                      active: false
                    },

                    {
                      title: 'Profile settings',
                      url: '/#/dashboard/Trainee/TraineeReg',
                      active: true
                    }
                  ]"
                ></vs-breadcrumb>
                <div class="frm-title">
                  <div class="heading">
                    <h3 class="text-secondary">PROFILE SETTINGS</h3>
                  </div>
                </div>
                <!-- ======================= -->
                <!-- tabs starts -->
                <div>
                  <vs-tabs
                    v-model="tabIndex"
                    alignment="fixed"
                    :color="(colorx = 'rgba(7, 167, 225, 0.61)')"
                  >
                    <vs-tab
                      icon="person"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Basic Information"
                      style="margin-top:20px;display:block !important;"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!-- Basic Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Basic Information</h6>
                          <!-- floating input starts -->
                          <div class="col-sm-12"></div>
                          <div class="col-sm-12">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="name"
                                type="text"
                                placeholder=" "
                                style="text-transform: default;"
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >account_circle</i
                                >
                              </span>
                              <label class="lbl-label">
                                Full Name
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                          <!-- <div class="col-sm-6 mt-3">
                            <label style="color: #07a7e19c !important;">Select Identity</label>
                            <selectize
                              id="select-state"
                              class="text-capitalize"
                              v-model="whichSelect"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in options1"
                                :key="index"
                                :value="item.value"
                                class="text-capitalize"
                              >{{item.text}}</option>
                            </selectize>
                          </div>-->
                          <div class="row col-sm-12">
                            <div class="col-sm-6 mt-4">
                              <!-- v-if="whichSelect == 0" -->
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="passport"
                                  disabled
                                  type="text"
                                  placeholder=" "
                                />
                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >credit_card</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Passport
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>

                            <div class="col-sm-6 mt-4">
                              <!-- v-if="whichSelect == 1" -->
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-mask="'(99999) 9999999-9'"
                                  v-model="cnic"
                                  disabled
                                  type="text"
                                  placeholder=" "
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >credit_card</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  CNIC Number
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                          </div>
                          <!-- Gender starts -->
                          <div
                            class="col-sm-12 mt-4"
                            style="color: #07a7e19c !important;"
                          >
                            <div class="row">
                              <label class="col-sm-2">
                                <b>Gender</b>
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <div class="col-sm-2">
                                <vs-radio
                                  v-model="gender"
                                  vs-name="radios1"
                                  vs-value="male"
                                  class="text-dark"
                                  >Male</vs-radio
                                >
                              </div>
                              <div class="col-sm-2">
                                <vs-radio
                                  v-model="gender"
                                  vs-name="radios1"
                                  vs-value="female"
                                  class="text-dark"
                                  >Female</vs-radio
                                >
                              </div>
                              <div class="col-sm-2">
                                <vs-radio
                                  v-model="gender"
                                  vs-name="radios1"
                                  vs-value="rather not say"
                                  class="text-dark"
                                  >Rather not say</vs-radio
                                >
                              </div>
                            </div>
                          </div>
                          <!-- Gender ends -->
                          <!-- Address starts -->
                          <div class="row col-sm-12">
                            <div class="col-sm-6 mt-4">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="mobilenumber"
                                  type="text"
                                  v-mask="'(9999) 9999999'"
                                  placeholder=" "
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >local_phone</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Mobile Number
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-4">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="email"
                                  disabled
                                  type="text"
                                  :name="email"
                                  placeholder=" "
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >email</i
                                  >
                                </span>
                                <label
                                  class="lbl-label"
                                  :for="email"
                                  name="email"
                                >
                                  Email
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                                <!-- <h3> {{name}}</h3> -->
                              </div>
                            </div>
                            <div class="col-sm-12 mt-3">
                              <label style="color: #07a7e19c !important;">
                                District
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <selectize
                                v-model="district"
                                :settings="districtSetting"
                                :searchable="true"
                              >
                                <option
                                  v-for="(item, index) in districtArr"
                                  :key="index"
                                  :value="item.id"
                                  :text="item.title"
                                  >{{ item.title }}, {{ item.province.title }},
                                  {{ item.province.country.title }}</option
                                >
                              </selectize>
                            </div>
                            <!-- floating input starts -->
                            <div class="col-sm-12 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="address"
                                  name="address"
                                  type="text"
                                  placeholder=" "
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >place</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Address
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                            <!-- floating input ends -->
                          </div>
                          <!-- Address ends -->
                        </div>
                        <!-- Basic Information ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex++"
                        class="save-btn"
                        variant="primary"
                        style="margin-top:100px"
                        >Next</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                    <vs-tab
                      icon="business_center"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Employment Information"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!--Employment Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Employment Information</h6>
                          <!-- Accademic Qualification starts -->
                          <div class="col-sm-12">
                            <!-- <h6 style="color:#212529;font-size:15px;">Accademic Qualification</h6> -->
                            <div class="table-responsive-sm">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Department Name
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <!-- <th scope="col">Degree Name</th>
                                    <th scope="col">Degree Subject</th>-->
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Designation / Rank
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <!-- <th scope="col"></th> -->
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <div>
                                        <selectize
                                          style="width:100%"
                                          label="Country"
                                          id="select-state"
                                          v-model="departmentname"
                                          :settings="departmentSetting"
                                          :searchable="true"
                                        >
                                          <option
                                            v-for="(item, index) in department"
                                            :key="index"
                                            :value="item.id"
                                            :text="item.title"
                                            >{{ item.title }}</option
                                          >
                                        </selectize>
                                        <!--  <input
                                          style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          v-model="departmentname"
                                          class="form-control"
                                          id="inputtext"
                                          placeholder
                                        /> -->
                                      </div>
                                    </td>

                                    <td>
                                      <div>
                                        <selectize
                                          style="width:100%"
                                          label="Country"
                                          id="select-state"
                                          v-model="designation"
                                          :settings="departmentSetting"
                                          :searchable="true"
                                        >
                                          <option
                                            v-for="(item,
                                            index) in designationT"
                                            :key="index"
                                            :value="item.id"
                                            :text="item.title"
                                            >{{ item.title }}</option
                                          >
                                        </selectize>
                                        <!--  <input
                                          style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          v-model="designation"
                                          class="form-control"
                                          id="inputtext"
                                          placeholder
                                        /> -->
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- Accademic Qualification ends -->
                        </div>
                        <!--Employment Information ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex++"
                        class="save-btn"
                        variant="primary"
                        style="margin-top:100px !important"
                        >Next</b-button
                      >
                      <!-- next button ends -->
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex--"
                        class="previous-btn"
                        variant="primary"
                        style="margin-top:100px !important"
                        >Previous</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                    <vs-tab
                      icon="school"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Academic Qualification"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!--Academic Qualification (Last Attended Degree) starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">
                            Academic Qualification (Last Attended Degree)
                          </h6>
                          <!-- Employment Record starts -->
                          <div class="col-sm-12">
                            <div class>
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Degree / Certificate
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Passing Year
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      University / Institute / School
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <div>
                                        <selectize
                                          style="width:100%"
                                          label="Country"
                                          id="select-state"
                                          v-model="certificate"
                                          :settings="certificateSetting"
                                          :searchable="true"
                                        >
                                          <option
                                            v-for="(item,
                                            index) in degreenameArr"
                                            :key="index"
                                            :value="item.id"
                                            :text="item.title"
                                            >{{ item.title }}</option
                                          >
                                        </selectize>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="col-xs-12">
                                        <input
                                          style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          v-model="passing_year"
                                          v-mask="'9999'"
                                          class="form-control"
                                          id="inputtext"
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div class="col-xs-12">
                                        <input
                                          style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          v-model="institute"
                                          class="form-control"
                                          id="inputtext"
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- Employment Record ends -->
                        </div>
                        <!--Academic Qualification (Last Attended Degree) ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        type="submit"
                        class="save-btn"
                        variant="primary"
                        style="margin-top:100px !important"
                        >Submit</b-button
                      >

                      <!-- next button ends -->
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex--"
                        class="previous-btn"
                        variant="primary"
                        style="margin-top:100px !important"
                        >Previous</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                  </vs-tabs>
                </div>
                <!-- tabs ends -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import MainSidebar from "./main-sidebar";
import Selectize from "vue2-selectize";
import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
export default {
  data: () => ({
    updateTraining: [],
    errors: [],
    department: [],
    designationT: [],
    name: "",
    passport: "",
    cnic: "",
    gender: "",
    mobilenumber: "",
    email: "",
    country: "",
    province: "",
    district: "",
    address: "",
    departmentname: "",
    designation: "",
    certificate: "",
    certificateSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Degree "
    },
    departmentSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Department "
    },
    designationSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Designation "
    },
    passing_year: "",
    institute: "",
    districtSetting: {
      searchField: "text",
      placeholder: "Select district here"
    },
    isSidebar: false,
    whichSelect: 0,
    options1: [
      { text: "Passport", value: 0 },
      { text: "CNIC", value: 1 }
    ],
    radios1: "",
    isForm: true,
    isFormData: false,
    tabIndex: 0,
    contact_person: "",
    contact_number: "",
    contact_email: "",

    colorx: "#1db952",
    countryArr: [],
    provinceArr: [],
    districtArr: [],

    degreenameArr: []
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    //select all district
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.department = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainee/designation/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.designationT = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.districtArr = response.data;
      });
    //select all degree names
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/degreenames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.degreenameArr = response.data;
      });
    //trainee show in form
    let userId = JSON.parse(localStorage.getItem("currentUser"));
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/traine/show/form/" + userId.id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data.address != null) {
          this.address = response.data.address;
        }
        if (response.data.userstrainee.name != null) {
          this.name = response.data.userstrainee.name;
        }
        if (response.data.cnic != null && response.data.cnic != "") {
          this.whichSelect = 1;
          this.cnic = response.data.cnic;
        }
        if (response.data.userstrainee.username != null) {
          this.email = response.data.userstrainee.username;
        }
        if (
          response.data.passportNo != null &&
          response.data.passportNo != ""
        ) {
          this.whichSelect = 0;
          this.passport = response.data.passportNo;
        }
        if (response.data.userstrainee.contactNo != null) {
          this.mobilenumber = response.data.userstrainee.contactNo;
        }
        if (response.data.gender != null) {
          this.gender = response.data.gender;
        }

        if (response.data.district_id != null) {
          this.district = response.data.district_id;
        }
        if (response.data.department_name != null) {
          this.departmentname = response.data.department_name;
        }
        if (response.data.designation != null) {
          this.designation = response.data.designation;
        }
        if (response.data.certificate != null) {
          this.certificate = response.data.certificate;
        }
        if (response.data.passingYear != null) {
          this.passing_year = response.data.passingYear;
        }
        if (response.data.institution != null) {
          this.institute = response.data.institution;
        }
      });
  },

  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-main-sidebar": MainSidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    TraineeForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.gender) {
        this.inValid.push("Gender type is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.district) {
        this.inValid.push("District is required.");
      }
      if (!this.address) {
        this.inValid.push("Address is required.");
      }
      if (!this.departmentname) {
        this.inValid.push("Department is required.");
      }
      if (!this.designation) {
        this.inValid.push("Designation is required.");
      }
      if (!this.certificate) {
        this.inValid.push("Certificate is required.");
      }
      if (!this.passing_year) {
        this.inValid.push("Passing Year is required.");
      }
      if (!this.institute) {
        this.inValid.push("Institute is required.");
      }

      //For phone number validation
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 11) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      var passing_y = this.passing_year;
      passing_y = passing_y.replace(/_/g, "");
      if (passing_y.length < 4) {
        this.inValid.push("Must be valid YEAR, 2020");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;

        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/register/trainee/reg", {
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            // cnic: this.cnic,
            // passport: this.passport,
            contactNo:phone_no1,
            district: this.district,
            address: this.address,
            department_name: this.departmentname,
            designation: this.designation,
            certificate: this.certificate,
            passing_year: this.passing_year,
            institute: this.institute,
            gender: this.gender,
            type: "Details Registration"
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.$router.push({ name: "traineeDashboard" });
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    resetForm() {
      this.name = "";
      this.cnic = "";
      this.passport = "";
      this.gender = "";
      this.mobilenumber = "";
      this.email = "";
      this.district = "";
      this.address = "";
      this.departmentname = "";
      this.designation = "";
      this.certificate = "";
      this.passing_year = "";
      this.institute = "";
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
/* 
.mt-45 {
  margin-top: 45px;
} */
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #ffffff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
/****  floating-Lable style end ****/
/* Floating label css ends */

.add-btn {
  font-size: 25px;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.previous-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: left;
  margin: 10px 0px;
}
</style>
